// ----------------------------------------------------------------------
// <copyright file="Izenda.MergeDuplicateMapping.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Merge Duplicate Mapping component
 */
!(function () {
  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');
  var MobxPropTypes = require('mobx-react').propTypes;
  var Input = require('share/components/controls/Izenda.Input');

  var actions = require('./Izenda.MappingDetailActions');

  var MergeDuplicateMapping = connect(actions)(function (props) {
    var localization = props.localization;
    return (
      <div className='checkbox u_paddingLeft u_paddingTop izenda-MappingDetail-MergeDuplicateMappings'>
        <label>
          <Input
            type='checkbox'
            checked={props.mergeDuplicateMappings}
            onChange={props.onChangeMergeDuplicateMappings} />
          {localization.getText('DATABASE_MAPPING_CHECKBOX_MERGE_DUPLICATE_MAPPINGS')}
          <span className='icon-info-circled' title={localization.getText('COPY_MANAGEMENT_MERGE_DUPLICATE_TOOLTIP')} />
        </label>
      </div>
    );
  });

  MergeDuplicateMapping.propTypes = {
    store: MobxPropTypes.observableObject
  };

  module.exports = MergeDuplicateMapping;
}());



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/DatabaseMapping/MappingDetail/Izenda.MergeDuplicateMapping.jsx